import React from "react";
import styled from "styled-components";
import {ellipsis} from "../../../style/styleConsts";
import OpenIdeaLinkBox from "../../idea/OpenIdeaLinkBox";
import howLongAgo from "../../../util/timeDescription";

const OpenTime = styled.div`
    width: 55px;
`;

const StockDetailsContainer = styled.div`
    ${ellipsis};
    margin-left: 10px;
    width: 190px;
`;

const Ticker = styled.span`
    font-weight: bold;
    margin-right: 0.4em;
`;

const StockDetails = ({idea}) => {
    return <StockDetailsContainer className="t-stock">
        <Ticker>{idea.stocks[0].bloomberg}</Ticker>
        {idea.stocks[0].name}
    </StockDetailsContainer>;
};

const AuthorIdea = ({idea, showDetail}) => {
    return <OpenIdeaLinkBox onClick={() => showDetail(idea.ideaId)}>
        <OpenTime className="date t-date">{howLongAgo(idea.openTimestamp)}</OpenTime>
        <StockDetails idea={idea}/>
    </OpenIdeaLinkBox>
};

export default AuthorIdea;